import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";

// Unified breadcrumb for the student pages. Every student breadcrumb
// (class content, Darssy AI, exercise view) renders through this so the
// font, size, colours and separator stay identical everywhere.
// `items`: [{ label, href?, onClick? }] — the last entry is the current page.
export default function StudentBreadcrumb({ items = [], sx }) {
  const trail = items.filter(Boolean);
  return (
    <Breadcrumbs sx={{ mb: 1.5, fontSize: 13, ...sx }} aria-label="Breadcrumb">
      {trail.map((item, index) => {
        const isLast = index === trail.length - 1;
        if (isLast) {
          return (
            <Typography
              key={index}
              sx={{ fontSize: 13, color: "#0f172a", fontWeight: 600 }}
              dir="auto"
            >
              {item.label}
            </Typography>
          );
        }
        if (item.onClick) {
          return (
            <Link
              key={index}
              component="button"
              type="button"
              underline="hover"
              color="inherit"
              onClick={item.onClick}
              dir="auto"
              sx={{ fontSize: 13, border: 0, p: 0, bgcolor: "transparent", font: "inherit", cursor: "pointer" }}
            >
              {item.label}
            </Link>
          );
        }
        return (
          <Link
            key={index}
            underline="hover"
            color="inherit"
            href={item.href}
            dir="auto"
            sx={{ fontSize: 13 }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
